import React from "react";
import { Button as Btn } from "@mantine/core";

export const Button = ({
  color = "blue",
  disabled,
  radius,
  size = "md",
  type,
  variant,
  gradient,
  fullWidth,
  compact,
  loaderPosition,
  loaderProps,
  loading,
  uppercase,
  rightIcon,
  leftIcon,
  children,
  p,
  py,
  px,
  pt,
  pb,
  pl,
  pr,
  m,
  my,
  mx,
  mt = "xs",
  mb,
  ml,
  mr,
  onClick,
  style,
  hidden,
  ...rest
}) => {
  return (
    <Btn
      pt={pt}
      mt={mt}
      type={type}
      color={color}
      disabled={disabled}
      radius={radius}
      size={size}
      variant={variant}
      gradient={gradient}
      fullWidth={fullWidth}
      compact={compact}
      loaderPosition={loaderPosition}
      loaderProps={loaderProps}
      loading={loading}
      uppercase={uppercase}
      rightIcon={rightIcon}
      leftIcon={leftIcon}
      onClick={onClick}
      style={style}
      hidden={hidden}
      {...rest}
    >
      {children}
    </Btn>
  );
};
